const MOBILE_WIDTH_LIMIT = 711
const DESKTOP_WIDTH_START = 1024
const DESKTOP_HEIGHT_START = 1024

export const isMobile = window.innerWidth < MOBILE_WIDTH_LIMIT && window.innerHeight < DESKTOP_HEIGHT_START
export const isTablet = window.innerWidth < DESKTOP_WIDTH_START && window.innerWidth > MOBILE_WIDTH_LIMIT && window.innerHeight >= DESKTOP_HEIGHT_START
export const isDesktop = window.innerWidth >= DESKTOP_WIDTH_START && ((window.screen && window.screen.orientation && window.screen.orientation.type.includes('landscape')) || (window.matchMedia("(orientation: landscape)").matches))
export const isPortrait = (window.screen && window.screen.orientation && window.screen.orientation.type.includes('portrait')) || window.matchMedia("(orientation: portrait)").matches
export const isMobileOrTablet = isMobile || isTablet
export const isXlDevice = !isMobile && !isTablet

export const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const isFullMobile = isMobile && isMobileAgent

export const isPwa = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true


export function scrollBottom (ref, smooth = false) {
	if (ref) {
		if (smooth) {
			ref.scrollTo({
				top: ref.scrollHeight,
				behavior: 'smooth'
			})
		} else {
			ref.scrollTop = ref.scrollHeight
		}
	}
}

export function centerScreen (ref) {
	if (ref) {
		ref.scrollIntoView({
			block: 'end',
			behavior: 'smooth'
		})
	}
}

export function hideSmartsuppChat () {
	const smartsuppElem = document.querySelector('#smartsupp-widget-container > div')
	if (smartsuppElem) {
		smartsuppElem.style.display = 'none'
	}
}

export default {
	isMobile,
	isTablet,
	isDesktop,
	isPortrait,
	isMobileOrTablet,
	isXlDevice,
	isMobileAgent,
	isFullMobile,
	isPwa,
	scrollBottom,
	centerScreen,
	hideSmartsuppChat
}


// WEBPACK FOOTER //
// ./src/helpers/ui.helpers.js